import React from 'react';

export interface IJSONLD {
  json: object;
  dangerouslyExposeHtml?: boolean;
}

function getInnerHTML(json: object) {
  return { __html: JSON.stringify(json) };
}

export const JSONLD = ({ json, dangerouslyExposeHtml }: IJSONLD) => {
  return dangerouslyExposeHtml ? (
    <script type="application/ld+json" dangerouslySetInnerHTML={getInnerHTML(json)} />
  ) : (
    <script type="application/ld+json">{JSON.stringify(json)}</script>
  );
};

export default JSONLD;
